import * as types from './types';
const getters = {
  [types.ESTIMATION]: state => state.estimation,
  [types.ESTIMATION_LIST]: state => state.estimationList,
  [types.AUTO_ESTIMATION]: state => state.autoEstimation,
  [types.ESTIMATION_MODEL]: state => state.estimationModel,

  [types.QUOTATION]: state => state.quotation,
  [types.QUOTATION_LIST]: state => state.quotationList,
};

export default getters;
